import React from "react";
import { CButton, CToast, CToastBody, CToastHeader, CToaster } from "@coreui/react";
import { useToasts } from "@src/hooks/useToasts";

export const ToastManager: React.FC = () => {
  const { toasts, hideToast } = useToasts();

  const getDefaultTitle = (type: string): string => {
    switch (type) {
      case "danger":
        return "Error";
      case "info":
        return "Info";
      case "success":
        return "Success";
      case "warning":
        return "Warning";
      case "primary":
        return "Primary";
      case "secondary":
        return "Secondary";
      case "light":
        return "Light";
      case "dark":
        return "Dark";
      default:
        return "Notification";
    }
  };

  const handleClose = (toastId: string) => () => {
    hideToast(toastId);
  };

  return (
    <CToaster id="ToastManager" placement="top-end" className="td-toaster">
      {toasts.map((toast) => (
        <CToast
          key={toast.id}
          autohide
          visible
          delay={toast.timeout}
          color={toast.type}
          className="td-toast"
          onClose={handleClose(toast.id)}
        >
          <CToastHeader closeButton>
            <strong className="me-auto">{toast.title || getDefaultTitle(toast.type)}</strong>
          </CToastHeader>
          <CToastBody>
            <div className="td-toast-message">{toast.message}</div>

            {toast.actions && toast.actions.length > 0 && (
              <div className="td-toast-actions">
                {toast.actions.map((action) => (
                  <CButton
                    key={action.id ?? action.label}
                    size="sm"
                    color={action.color || "light"}
                    onClick={action.onClick}
                  >
                    {action.label}
                  </CButton>
                ))}
              </div>
            )}
          </CToastBody>
        </CToast>
      ))}
    </CToaster>
  );
};
